import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  useReportMutation$data,
  type useReportMutation as UseReportMutation
} from '@/__generated__/useReportMutation.graphql'

type CommitAsyncFn = (toUserId: string, message: string) => Promise<useReportMutation$data>

export const useReportMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isReporting] = useMutation<UseReportMutation>(graphql`
    mutation useReportMutation($input: CreateReportInput!) {
      createReport(input: $input) {
        clientMutationId
        query {
          currentUser {
            ...MessagesView_user
            ...LikesList_user
          }
        }
      }
    }
  `)

  const report = useCallback<CommitAsyncFn>(
    (toUserId: string, message: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              report: {
                message,
                toUserId
              }
            }
          }
        })
      ),
    [commit]
  )

  return [report, isReporting]
}
